import aliexpress from './aliexpress';

export default {
  aliexpress
}
